import React, { Component } from 'react'
import { X } from '@everlane/icon'
import { VelocityTransitionGroup } from 'velocity-react'
import CountrySelection from 'base/react/components/country_selection'

class CountrySelectModal extends Component {
  constructor(props) {
    super(props)
    this.modalBackground = React.createRef()
  }

  state = {
    display: false,
  }

  componentDidMount() {
    this.setState({ display: true })
    document.body.classList.add('noscroll')
  }

  componentWillUnmount() {
    this.setState({ display: false })
    document.body.classList.remove('noscroll')
  }

  renderModalContent() {
    return (
      <div className="country-select-modal">
        <div className="country-select-modal__wrapper">
          <X onClick={this.props.onRequestClose} className="country-select-modal__close-button" />
          <div className="country-select-modal__content">
            <CountrySelection
              forMobile={false}
              closeCountrySelectTray={this.props.onRequestClose}
            />
          </div>
        </div>
      </div>
    )
  }

  detectBackgroundClick(e) {
    if (e.target === this.modalBackground.current) {
      this.props.onRequestClose()
    }
  }

  render() {
    return (
      <div
        onClick={e => this.detectBackgroundClick(e)}
        className="modal__bg modal__bg--default"
        ref={this.modalBackground}
      >
        <VelocityTransitionGroup
          enter={{
            animation: 'transition.slideUpIn',
            duration: 700,
            delay: this.props.enterDelay,
          }}
          leave={{
            animation: 'transition.slideDownOut',
            duration: 700,
          }}
        >
          {this.state.display && this.renderModalContent()}
        </VelocityTransitionGroup>
      </div>
    )
  }
}

export default CountrySelectModal
